import { Input } from '@angular/core';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbDate, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-range-date-picker',
  templateUrl: './range-date-picker.component.html',
  styleUrls: ['./range-date-picker.component.scss']
})
export class RangeDatePickerComponent {
  @Output() selectedDates = new EventEmitter<any>();
  hoveredDate: NgbDate | null = null;
  @Input() reset: boolean;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  @Input() selectedData: any;

  constructor(private calendar: NgbCalendar, public formatter: NgbDateParserFormatter) {

  }

  ngOnInit() {

  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
    this.selectedDates.emit({ from: this.fromDate, to: this.toDate });
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }
  valueChanged(eve, status) {
    console.log(eve.value, status);
    if (!this.fromDate && !this.toDate) {
      this.selectedDates.emit({ from: null, to: null });
    } else if (!eve.value && status == 'from') {
      this.selectedDates.emit({ from: null, to: this.toDate });
      this.fromDate = null;
    } else if (!eve.value && status == 'to') {
      this.selectedDates.emit({ from: this.fromDate, to: null });
      this.toDate = null;
    }
  }

}
